export default __webpack_public_path__ + "img/e949f47c684a08f99acd718f3a1073e3.png";